import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import { CommonEventProperties } from '../../utils/CommonParams'

export const FilterAppliedEventSchema: EventSchema = {
  eventName: EN.FILTER_APPLIED,
  params: {
    ...CommonEventProperties,
    BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
    EVENT_CATEGORY: EPK.EVENT_CATEGORY,
    STORE_ID_SAP: EPK.STORE_ID_SAP,
    STORE_ID_DBP: EPK.STORE_ID_DBP,
    FILTER_CATEGORY: EPK.FILTER_CATEGORY,
    FILTER_DETAIL: EPK.FILTER_DETAIL,
  },
}
